import { useGameState } from '@/stores/gameState'
import { removeAuthToken } from '@/helpers/storage'

export const logOut = () => {
  const { clean } = useGameState()
  clean()
  removeAuthToken()
  window.location.reload()
}
